import { GetStarted } from 'routes/manifest';
import { ROUTE_PATHS as luiIdvRoutePaths } from '@cbbt/lui-idv';

/* FORM FIELDS */
export const BUSINESS_NAME = 'businessName';
export const SORT_CODE = 'sortCode';
export const ACCOUNT_NUMBER = 'accountNumber';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const DATE_OF_BIRTH = 'dateOfBirth-day';
export const EMAIL_ADDRESS = 'emailAddress';
export const CONFIRM_EMAIL_ADDRESS = 'confirmYourEmailAddress';
export const AGREE_TO_TERMS_AND_CONDITIONS = 'agreeToTermsAndConditions';

/* PAGES */
export const LANDING_PAGE_PATH = `/${GetStarted}`;

/* NATIVE STORAGE VARIABLE NAMES */
export const GLOBAL_IDS = 'globalIds';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';

/* FORM FIELDS REGEX */
export const BUSINESS_NAME_PATTERN = /^[a-zA-Z0-9_@&+\-./'() ]+$/;
export const SORT_CODE_PATTERN = /^\d{6}$|\d{2}([- ])\d{2}([- ])\d{2}$/;
export const ACCOUNT_NUMBER_PATTERN = /^[0-9]{8}$/;
export const HOCA_SORT_CODE_PATTERN = /^(30 00 00|300000|30-00-00)$/;
export const FIRST_NAME_PATTERN = /^[a-zA-Z0-9_@&+\-./'() ]+$/;
export const LAST_NAME_PATTERN = /^[a-zA-Z0-9_@&+\-./'() ]+$/;
export const EMAIL_ADDRESS_PATTERN =
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;

/* ABOUT THE BUSINESS ERROR REASON CODES */
export const BUSINESS_INVALID_ERROR_CODE = [
  'LBG_REG_JOURNEY_CLIENT_10203',
  'LBG_REG_JOURNEY_CLIENT_10207',
];

/* ERROR REASON CODES */
export const FIELD_NAME_MISSING_SPECIFICATION = 'LBG_REG_JOURNEY_CLIENT_10104';
export const INCORRECT_REQUEST_HEADER = 'LBG_REG_JOURNEY_CLIENT_10105';
export const RETRIEVE_PARTY_DETAILS_FAILURE = 'LBG_REG_JOURNEY_CLIENT_10301';
export const NO_OCIS_FOUND_CODE = 'LBG_REG_JOURNEY_CLIENT_10302';
export const INDIVIDUAL_PHONE_NUMBER_NOT_FOUND = 'LBG_REG_JOURNEY_CLIENT_10303';
export const MAYFAIR_ACCOUNT_CODE = 'LBG_REG_JOURNEY_CLIENT_10204';
export const REGISTRATION_IN_PROGRESS_ERROR_CODE =
  'LBG_REG_JOURNEY_CLIENT_10305';
export const MANDATE_EXIST_CODE = 'LBG_REG_JOURNEY_CLIENT_10306';

/* HTTP METHODS */
export const GET = 'GET';
export const POST = 'POST';

export const configKey = 'api_endpoint_config';
export const configPath = `${process.env.BASE_PATH.replace(
  /\/\s*$/,
  '',
)}/config.json`;

export const CONSTANTS = Object.freeze({
  Brand: {
    bos: 'BOS',
    lloyds: 'LYDS',
  },
});

/* REQUEST PARAMS */
export const CUS = 'CUS';
export const JOURNEY_ID = 'DA1';
export const DOC_CATEGORY = 'IDV_DA1';

export const DEPENDENCY_PAGES = {
  aboutYou: '/about-you',
  registrationInProgress: '/registration-in-progress',
  smsOtp: '/sms-otp',
  idv: /^\/idv(\/.*)?$/,
  submitYourRegistration: '/submit-your-registration',
};

export const CONFIG_KEYS = {
  idvApiHostPath: 'IA_LAB_IDV_API_HOST_PATH',
  docApiHostPath: 'IA_LAB_DOC_API_HOST_PATH',
  svcIdvApiHostPath: 'SVC_IDV_BASE_PATH',
  idvSubscriptionKey: 'IDV-SUBSCRIPTION-KEY',
  smsRedirectEndpoint: 'SMS_REDIRECT_ENDPOINT',
};

export const MITEK_LICENCE =
  'eyJzaWduYXR1cmUiOiJqU2MzWExnY0FybUFRZE8yNjRGb0dOQWpPQzZKQlFKYmJPSnB2UnVydWFNdi9FSWNLOEtoZlZVRFU5R3pjVFlmbk5IRmg2c3VsQ2IvYk9QbjVkbXMxNEd4K2M4TXlhdUNWQ3RwK2QvMDZ0TzhnZjRoQmZtK1orWmFTekk0OGtUQm51Ull4V1EzVnhEVGd5eDkrUlkwOE1lV2YrSlIyOEVkQ0Q0Sm5WU3l1bUJhTitUc0ViRENsYlNXeGJGdHBldWZTTlByV0VQS25vVUZYRHVObGV6UGtoVnlVaVNvRnBpcS84SGVBUzVITGtNaERZR1pPMnBtbWUycHRMUmhGK2xLM2VoM3JjVUVveE9MaUJ6WkhFb1ZZVUJmamNPSlJuKytrb21LSXNxazV6QmkrYWxETlQxcmxiVzJVc2lWalJoUWFOTDdmc0tyTE9rSFVoNERSdkdtbHc9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDI0LTA3LTMxIiwiZmVhdHVyZXMiOlsiZ2VuZXJpYyIsImlkIiwiZmFjZSIsIm5mYyIsInZvaWNlIiwib2RjIiwib2RlIiwiZW0iXSwiYXBwbGljYXRpb25JZGVudGlmaWVyIjp7IndlYiI6WyJjYmJ0Lm9yaWcuY29tbS5pbnQubGJnY3RzLmNsb3VkLnRlc3QuZ3JvdXAiLCJjYmJ0LWNvbW0tb3JpZy50ZXN0Lmxsb3lkc2JhbmtpbmcuY2xvdWQiLCJjYmJ0LWJvcy1jb21tLW9yaWcudGVzdC5sbG95ZHNiYW5raW5nLmNsb3VkIiwiY2JidC1ib3Mub3JpZy5jb21tLmludC5sYmdjdHMuY2xvdWQudGVzdC5ncm91cCIsInByZXZpZXcuYmNiLW9uYm9hcmRpbmcuZGlnaXRhbC5sbG95ZHNiYW5rLmNvLnVrIiwibGJnYXpvcmlnaW4ucHJldmlldy5iY2Itb25ib2FyZGluZy5kaWdpdGFsLmxsb3lkc2JhbmsuY28udWsiXX0sImdwbyI6IjE2ZCIsIm9yZ2FuaXphdGlvbiI6Ik1pdGVrIFN5c3RlbXMgSW5jLiIsInZlcnNpb24iOiIxLjAifX0=';

export const IA_LAB_HEADERS_BOS = {
  channel: '1',
  journey: 'COB',
  product: 'COBCMP',
  brand: 'BOS',
};

export const IA_LAB_HEADERS_LTB = {
  channel: '1',
  journey: 'COL',
  product: 'COLCMP',
  brand: 'LTB',
};

export const APP_REFERENCE_ID = 'AL21166';

export const IDV_SUBMIT_STATUS = {
  passed: 'PASSED',
  passToAgent: 'PASS_TO_AGENT',
  hardFail: 'HARD_FAIL',
};

export const IDV_CAPTURE_SELFIE_PATH = `/idv/${luiIdvRoutePaths.CAPTURE_SELFIE_PHOTO}`;
